import React from 'react';
import { ListItemIcon, MenuItem } from '@mui/material';
import ScienceIcon from '@mui/icons-material/Science';
import MenuItemHiddenTextLabel from '../../common/MenuItemHiddenTextLabel';
import IconButtonWhiteBg from '../../common/IconButtonWhiteBg';
import { IExtractionBatch } from '../../../types/my-types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useGlynt from '../../hooks/useGlynt';

interface IProps {
  extractionBatch: IExtractionBatch;
  handleClose?: () => void;
  type: 'menu' | 'icon';
}

const ExtractionBatchExperimental: React.FC<IProps> = ({ extractionBatch, handleClose, type }) => {
  const glynt = useGlynt();
  const queryClient = useQueryClient();

  const updateExperimentalMutation = useMutation({
    mutationFn: async (isExperimental: boolean) => {
      return (await glynt).extractionBatch.update(extractionBatch.id, {
        is_experimental: isExperimental,
      });
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['extractionBatches']
      });
      queryClient.invalidateQueries({
        queryKey: ['extractionBatch', extractionBatch.id]
      });
      if (handleClose) handleClose();
    }
  });

  const handleClick = () => {
    updateExperimentalMutation.mutate(!extractionBatch.is_experimental);
  };

  const label = extractionBatch.is_experimental ? 'Remove Experimental' : 'Mark as Experimental';

  if (type === 'icon') {
    return (
      <IconButtonWhiteBg
        onClick={handleClick}
        disabled={updateExperimentalMutation.isPending}
        id="btn-toggle-experimental"
        cypressId="btn-toggle-experimental"
        tooltip={label}
      >
        <ScienceIcon
          style={{
            fontSize: '15px',
            color: extractionBatch.is_experimental ? '#1565c0' : 'black',
          }}
        />
      </IconButtonWhiteBg>
    );
  }

  return (
    <MenuItem
      onClick={handleClick}
      disabled={updateExperimentalMutation.isPending}
      sx={{ fontSize: '0.875rem', padding: '4px 8px' }}
      data-cy={`btn-toggle-experimental-${extractionBatch.label}`}
    >
      <ListItemIcon>
        <ScienceIcon fontSize="small" />
      </ListItemIcon>
      <MenuItemHiddenTextLabel>{label}</MenuItemHiddenTextLabel>
    </MenuItem>
  );
};

export default ExtractionBatchExperimental;
